/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-05-19 18:50:38
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\user\success\locales\en-US.ts
 */
export default {
  'page.success.txtsucess': 'After successful registration, please log in and timely authenticate and improve your personal information.',
  'page.activation.txterror': 'Login has failed',
  'page.success.login': 'Login',
};
